import { isAfter, isEqual, parse } from 'date-fns';
import Api from '../api/Api';
import resolve from  '../util/Configuracao';
class PrestadorApi extends Api {
  async consultarNomesTodosPrestadores () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosPrestadores');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarNomesTodosPrestadoresCredenciados () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosPrestadoresCredenciados');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesPrestadoresComCnpj (indAtivo) {
    try {
      const urlConsultarPrestadoresComCnpj = resolve('urlConsultarPrestadoresComCnpj') + '/' + indAtivo;
      const response = await this.fetch(urlConsultarPrestadoresComCnpj);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  } 
  async consultarGruposPrestadores (nomeGrupo) {
    let grupos = [];
    const brancoAcoes = '';
        try {
      const urlGruposPrestadores = resolve('urlGruposPrestadores') + nomeGrupo + '/tipo/T';
      const { data } = await this.fetch(urlGruposPrestadores);
      data.map(res => {
        const { codGrupoPrestador, desGrupoPrestador, indGrupoOdontologico, qtdePrestadores } = res;
        grupos.push(Object.values({ codGrupoPrestador, desGrupoPrestador, indGrupoOdontologico, qtdePrestadores, brancoAcoes }));
      });
      return grupos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarNomesTodosGrupos () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosGrupos');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarNomesGruposPorTipo (tipoGrupo) {
    try {
      const urlConsultarNomesGruposPorTipo = resolve('urlConsultarNomesGruposPorTipo') + tipoGrupo;
      const response = await this.fetch(urlConsultarNomesGruposPorTipo);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async excluirGruposEmLote (grupos) {
    await this.excluirGrupos(grupos);
  }

  async excluirGrupos (grupos) {
    try {
      const excluirGrupoUrl = resolve('urlExcluirGrupo');
      await this.fetch(excluirGrupoUrl, 'put', grupos);
    } catch (error) {
      console.error(error);
    }
  }

  async incluirGrupo (grupo) {
    try {
      const incluirGrupoUrl = resolve('urlIncluirGrupo');
      const response = await this.fetch(incluirGrupoUrl, 'put', grupo); // , {'content-type': 'application/json'});
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarGrupo (grupo) {
    try {
      const alterarGrupoUrl = resolve('urlAlterarGrupo');
      const response = await this.fetch(alterarGrupoUrl, 'put', grupo); // , {'content-type': 'application/json'});
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestadoresVinculados (codGrupo, indGrupoOdontologico) {
    try {
      const urlPrestadoresVinculados = resolve('urlPrestadoresVinculados') + codGrupo + '/grupo_odontologico/' + indGrupoOdontologico;
      const response = await this.fetch(urlPrestadoresVinculados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestadoresDesvinculados (codGrupo) {
    try {
      const urlPrestadoresDesvinculados = resolve('urlPrestadoresDesvinculados') + codGrupo;
      const response = await this.fetch(urlPrestadoresDesvinculados);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async vincularPrestadoresEmLote (grupo) {
    try {
      const urlVincularPrestadoresEmLote = resolve('urlVincularPrestadoresEmLote');
      const result = await this.fetch(urlVincularPrestadoresEmLote, 'PUT', grupo, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async desvincularPrestadoresEmLote (grupo) {
    try {
      const urlDesvincularPrestadoresEmLote = resolve('urlDesvincularPrestadoresEmLote');
      const result = await this.fetch(urlDesvincularPrestadoresEmLote, 'PUT', grupo, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestador (CPF_CNPJ, nome) {
    let prestadores = [];
    const brancoAcoes = '';
    let cpfCnpj = '';
    try {
      const urlPrestador = resolve('urlPrestador') + CPF_CNPJ + '/nome/' + nome;
      const { data } = await this.fetch(urlPrestador);
      data.map(res => {
        const { codPrestador, txtSiglaPrestador, nomPrestador, indAtivo, indPessoaFisica, numCnpj, numCPF, nomFantasiaPrestador,
          desEmail, txtSite, codBanco, codAgencia, txtContaCorrente, numProcesso, anoProcesso, numContrato, anoContrato,
          indAssociacaoPrestadores, indEmiteNFAntecipada, indGerenciaInternacao, numOrgaoExterno, nomOrgaoExterno, nomBanco,
          nomAgencia, indPrestadorCredenciado, codGrupo, nomeGrupo, indGrupoOdontologico, codVersaoTiss, codProcessoAlteracoes,
        codProcessoCredenciamento, codProcessoPacotes, codProcessoReclamacao, codProcessoPae, txtDetalheContrato, nomRepresentanteLegal, indAtesteComissao} = res;
        cpfCnpj = indPessoaFisica === 'N' ? this.pad(numCnpj, 14) : this.pad(numCPF, 11);
        prestadores.push(Object.values({ codPrestador, txtSiglaPrestador,  nomPrestador,
          cpfCnpj, indAtivo, brancoAcoes, nomFantasiaPrestador, indPessoaFisica, desEmail, txtSite, codBanco,
          codAgencia, txtContaCorrente, numProcesso, anoProcesso, numContrato, anoContrato, indAssociacaoPrestadores,
          indEmiteNFAntecipada, indGerenciaInternacao, numOrgaoExterno, nomOrgaoExterno, nomBanco, nomAgencia,
          indPrestadorCredenciado, codGrupo, nomeGrupo, indGrupoOdontologico, codVersaoTiss, codProcessoAlteracoes,
          codProcessoCredenciamento, codProcessoPacotes, codProcessoReclamacao, codProcessoPae, txtDetalheContrato, nomRepresentanteLegal, indAtesteComissao
        }));
      });
      return prestadores || [];
    } catch (error) {
      console.error(error);
    }
  }
  async consultarPrestadoresSemOrgaoExterno () {
    let prestadores = [];
    const brancoAcoes = '';
    try {
      const urlPrestadorSemOrgaoExterno = resolve('urlPrestadorSemOrgaoExterno');
      const { data } = await this.fetch(urlPrestadorSemOrgaoExterno);
      let cpfCnpj = '';
      data.map(res => {
        const { codPrestador, nomPrestador, indPessoaFisica, numCnpj, numCPF } = res;
        cpfCnpj = indPessoaFisica === 'N' ? this.pad(numCnpj, 14) : this.pad(numCPF, 11);
        prestadores.push(Object.values({ codPrestador, nomPrestador, cpfCnpj, brancoAcoes}));
      });
      return prestadores || [];
    } catch (error) {
      console.error(error);
    }
  }
  async incluirPrestador (prestador) {
    try {
      const urlIncluirPrestador = resolve('urlIncluirPrestador');
      const response = await this.fetch(urlIncluirPrestador, 'put', prestador);
      return response;
    } catch (error) {
      console.error(error);
    }
  }

async incluirPrestadorOrgaoExterno (prestador) {
    try {
      const urlIncluirPrestadorOrgaoExterno = resolve('urlIncluirPrestadorOrgaoExterno');
      const response = await this.fetch(urlIncluirPrestadorOrgaoExterno, 'put', prestador);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarPrestador (prestador) {
    try {
      const urlAlterarPrestador = resolve('urlAlterarPrestador');
      const response = await this.fetch(urlAlterarPrestador, 'put', prestador);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirPrestadoresEmLote (prestadores) {
    try {
      const urlExcluirPrestadores = resolve('urlExcluirPrestadores');
      const result = await this.fetch(urlExcluirPrestadores, 'post', prestadores);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async vincularPrestadorOrgaoExterno (codPrestador, nomPrestador) {
    try {
      const urlVincularPrestadorOrgaoExterno = resolve('urlVincularPrestadorOrgaoExterno') + codPrestador + '/' + nomPrestador;
      const response = await this.fetch(urlVincularPrestadorOrgaoExterno, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEnderecos (codPrestador) {
    let enderecos = [];
    const brancoAcoes = '';
    try {
      const urlEnderecosPrestador = resolve('urlEnderecosPrestador') + codPrestador;
      const { data } = await this.fetch(urlEnderecosPrestador);
      data.map(res => {
        const { codEndereco, codPrestador, siglaUF, cidade, bairro, desEndereco, cep, indExibirApp, numero, complemento, nomeContato } = res;
        enderecos.push(Object.values({ codEndereco, codPrestador, siglaUF, cidade, bairro, desEndereco, cep, indExibirApp, nomeContato, brancoAcoes, numero, complemento }));
      });
      return enderecos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarDadosBancarios (codPrestador) {
    let dadosBancarios = [];
    try {
      const urlPrestadorDadosBancarios = resolve('urlPrestadorDadosBancarios') + codPrestador;
      const { data } = await this.fetch(urlPrestadorDadosBancarios);
      data.map(res => {
        const { codBanco, codAgencia, txtContaCorrente } = res;
        dadosBancarios.push(Object.values({ codBanco, codAgencia, txtContaCorrente }));
      });
      return dadosBancarios || [];
    } catch (error) {
      console.error(error);
    }
  }

  pad (str, max) {
    str = str.toString();
    return str.length < max ? this.pad('0' + str, max) : str;
  }
  async incluirEndereco (endereco) {
    try {
      const urlIncluirEndereco = resolve('urlIncluirEndereco');
      const result = await this.fetch(urlIncluirEndereco, 'put', endereco);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarEndereco (endereco) {
    try {
      const urlAlterarEndereco = resolve('urlAlterarEndereco');
      const result = await this.fetch(urlAlterarEndereco, 'put', endereco);
      return result;
    } catch (error) {
      console.error(error);
    }
  }

  async excluirEnderecosEmLote (enderecos) {
    try {
      const urlExcluirEnderecos = resolve('urlExcluirEnderecos');
      const result = await this.fetch(urlExcluirEnderecos, 'post', enderecos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }

 async consultarEspecialidadesDoPrestador (codPrestador) {
    try {
      const urlConsultarEspecialidadesDoPrestador = resolve('urlConsultarEspecialidadesDoPrestador') + codPrestador;
      const response = await this.fetch(urlConsultarEspecialidadesDoPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEspecialidadesNaoVinculadas (codPrestador) {
    try {
      const urlConsultarEspecialidadesNaoVinculadasAoPrestador = resolve('urlConsultarEspecialidadesNaoVinculadasAoPrestador') + codPrestador;
      const response = await this.fetch(urlConsultarEspecialidadesNaoVinculadasAoPrestador);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async vincularEspecialidades (codPrestador, especialidades) {
    try {
      const urlVincularEspecialidades = resolve('urlVincularEspecialidades') + codPrestador;
      await this.fetch(urlVincularEspecialidades, 'put', especialidades);
    } catch (error) {
      console.error(error);
    }
  }
  async desvincularEspecialidades (codPrestador, especialidades) {
    try {
      const urlDesincularEspecialidades = resolve('urlDesincularEspecialidades') + codPrestador;
      await this.fetch(urlDesincularEspecialidades, 'put', especialidades);
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCredenciamentos (codPrestador) {
    let credenciamentos = [];
    const brancoAcoes = '';
    try {
      const urlConsultarPrestadorCredenciamento = resolve('urlConsultarPrestadorCredenciamento') + codPrestador;
      const { data } = await this.fetch(urlConsultarPrestadorCredenciamento);
      data.map(res => {
        const { codCredenciamento, codPrestador, dtaInicio, dtaFim, indPeriodoOdontologico, txtObservacao } = res;
        credenciamentos.push(Object.values({ codCredenciamento, codPrestador, dtaInicio, dtaFim, indPeriodoOdontologico, txtObservacao, brancoAcoes }));
      });
      return credenciamentos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async salvarDataInicial (filter, data) {
    try {
      const salvarDataInicialPrestadorUrl = resolve('salvarDataInicialPrestadorUrl') + filter.codCredenciamento + '/data/' + parse(data);
      await this.fetch(salvarDataInicialPrestadorUrl, 'put');
      return 'Data alterada com sucesso.';
    } catch (error) {
      console.error(error);
      return 'Não foi possível realizar a alteração da data. Favor tentar novamente.';
    }
  }
  async salvarDataFim (filter, data) {
    try {
      const salvarDataFimPrestadorUrl = resolve('salvarDataFimPrestadorUrl') + filter.codCredenciamento + '/data/' + parse(data);
      await this.fetch(salvarDataFimPrestadorUrl, 'put');
      return 'Data final atualizada com sucesso.';
    } catch (error) {
      console.error(error);
      return 'Não foi possível realizar a alteração da data. Favor tentar novamente.';
    }
  }

  validarDataInicio (data, dataFim) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFim = dataFim === null ? dataNula : parse(parse(dataFim).setHours(0, 0, 0, 0));

    if (isEqual(data, dataNula) || data === undefined || data.toString() === 'Invalid Date') {
      return 'A data não pode ser nula.';
    }
    if (!isEqual(data, dataNula) && !isEqual(dataFim, dataNula) && isAfter(data, dataFim)) {
      return 'A data não pode ser maior que a data fim.';
    }
    return '';
  }
  validarDataFim (data, dataInicio) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));

    if (!isEqual(data, dataNula) && isAfter(dataInicio, data)) {
      return 'A data não pode ser menor que a data de início.';
    }
    return '';
  }
  async excluirCredenciamentosEmLote (credenciamentos) {
    try {
      const urlExcluirCredenciamentos = resolve('urlExcluirCredenciamentos');
      const result = await this.fetch(urlExcluirCredenciamentos, 'post', credenciamentos);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async validarCredenciamento (credenciamento, indInclusao) {
    try {
      const urlValidarCredenciamento = resolve('urlValidarCredenciamento') + indInclusao;
      const result = await this.fetch(urlValidarCredenciamento, 'post', credenciamento);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async incluirCredenciamento (credenciamento) {
    try {
      const urlIncluirCredenciamento = resolve('urlIncluirCredenciamento');
      const result = await this.fetch(urlIncluirCredenciamento, 'put', credenciamento);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarCredenciamento (credenciamento) {
    try {
      const urlAlterarCredenciamento = resolve('urlAlterarCredenciamento');
      const result = await this.fetch(urlAlterarCredenciamento, 'put', credenciamento);
      return result;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarTelefones (codPrestador) {
    let telefones = [];
    const brancoAcoes = '';
        try {
      const urlTelefonesPrestador = resolve('urlTelefonesPrestador') + codPrestador;
      const { data } = await this.fetch(urlTelefonesPrestador);
      data.map(res => {
        const { seqTelefone, codTipoTelefone, desTipoTelefone, codPrestador, numDDD, numTelefone, indExibirApp } = res;
        telefones.push(Object.values({ seqTelefone, codTipoTelefone, desTipoTelefone, codPrestador, numDDD, numTelefone, indExibirApp, brancoAcoes }));
      });
      return telefones || [];
    } catch (error) {
      console.error(error);
    }
  }

  async incluirTelefone (telefone) {
    try {
      const urlIncluirTelefone = resolve('urlIncluirTelefone');
      const result = await this.fetch(urlIncluirTelefone, 'put', telefone);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarTelefone (telefone) {
    try {
      const urlAlterarTelefone = resolve('urlAlterarTelefone');
      const result = await this.fetch(urlAlterarTelefone, 'put', telefone);
      return result;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirTelefonesEmLote (telefones) {
    try {
      const urlExcluirTelefones = resolve('urlExcluirTelefones');
      const result = await this.fetch(urlExcluirTelefones, 'post', telefones);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async validarPrestador (prestador, indInclusao) {
    try {
      const urlValidarPrestador = resolve('urlValidarPrestador') + indInclusao;
      const result = await this.fetch(urlValidarPrestador, 'post', prestador);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
}
export default PrestadorApi;
